export const WEAPON = {
  id: 'sniper',
  label: 'M700-LR',
  class: 'sniper',
  caliber: '7.62x51',
  /** Gold-coin price in the armory; 0 = free starter/melee, never purchasable. */
  price: 2000,
  /* Bolt-action: `rpm` stands in for the manual cycle time between rounds
   * rather than a mechanical rate of fire. */
  rpm: 45,
  modes: ['semi'],
  burstCount: 1,
  burstRpm: 45,
  burstDelay: 0.1,
  magSize: 5,
  reserve: 25,
  muzzleVelocity: 830,
  damage: 95,
  penetration: 1.4,
  dropoff: 0.7,
  maxRange: 800,
  dragK: 0.22,
  tracerEvery: 1,
  spreadHip: 4.0,
  spreadAds: 0.05,
  spreadPerShot: 0.6,
  spreadMax: 5.0,
  spreadDecay: 6.0,
  recoil: {
    pitch: 0.0165,
    yaw: 0.0018,
    kickBack: 0.028,
    kickUp: 0.011,
    roll: 0.04,
    punch: 0.55,
    freq: 6.5,
    damping: 0.5,
    patternLength: 5,
    patternSeed: 0x7e51a3,
    climbShape: [1.0],
    drift: 0.3,
  },
  adsTime: 0.35,
  adsFov: 0.32,
  viewFov: 0.84,
  reloadTac: 2.6,
  reloadEmpty: 3.4,
  inspectTime: 3.4,
  drawTime: 0.7,
  holsterTime: 0.45,
  hipPos: [0.11, -0.195, -0.335],
  hipRot: [-0.05, 0.078, -0.13],
  adsCant: [0, 0, 0.003],
  eyeRelief: 0.135,
  sprintPos: [0.09, -0.27, -0.29],
  sprintRot: [-0.4, 0.6, 0.2],
  lowReadyPos: [0.112, -0.29, -0.3],
  lowReadyRot: [-0.46, 0.125, -0.09],
  swayScale: 1.05,
  bobScale: 0.85,
  magLen: 0.22,
};

export const loadModel = () => import('../models/sniper.js').then((m) => m.buildSniper);
